import { useQuery } from "@tanstack/react-query";
import { identityQuery } from "../queries";

export interface UseIdentityOptions {
  authenticatedFetch: (url: string, init?: RequestInit) => Promise<Response>;
  directoryBaseUrl: string;
  enabled?: boolean;
}

/**
 * Hook to fetch the caller's resolved a3s identity.
 *
 * Returns the caller's `userId` (always a Vision Auth user id) and, if
 * applicable, the linked legacy (Django) `legacyUserId`. When a user is
 * authenticated through the legacy app, both ids are populated so that the
 * UI can recognise self-targeting actions against either identity.
 *
 * @see apps/a3s-dir/src/client-api/handle-me-identity.ts
 */
export function useIdentity(options: UseIdentityOptions) {
  const { enabled = true, ...config } = options;

  return useQuery({
    ...identityQuery(config),
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    refetchOnWindowFocus: false,
  });
}
